import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <div className="max-w-4xl pt-4 mx-auto">
      <div className="max-w-xl">
        <SEO title="Jobangebote" />
        <h1 className="mb-8 font-semibold text-black">
          Jobs
        </h1>

        <h3 className="text-lg mb-6 leading-snug text-black font-bold">
          Data Scientist/in
        </h3>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Du bist ein/e stark eigenverantwortlich arbeitende/r Data-Scientist/in und möchtest Publishern dabei helfen, Ihre Geschäftsziele mit Hilfe von Regressionsanalysen und cleveren ETL-Strategien zu erreichen?
          Dann melde Dich doch bei uns, denn wir suchen immer neue Talente.
        </p>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Wir bieten: Eine spannende Umgebung mit fähigen Kolleg/innen,
          komplexe Datenlagen in einem modernen AWS-Stack und Aktienoptionen an einem organisch wachsenden Unternehmen. Außerdem stellen wir Dir die Hardware, die Du brauchst: das Audyem-Team arbeitet remote.
        </p>
        <p className="text-lg mb-16 leading-snug text-gray-800">
          Sende Deine Bewerbungsunterlagen inklusive Lebenslauf und Links zu persönlicher Website, Portfolio oder Github/Gitlab-Account an <a className="text-black" href="mailto:join@audyem.com&subject=Bewerbung+als+Data+Scientist/in">join@audyem.com</a>. Wir freuen uns!
        </p>

        <h3 className="text-lg mb-6 leading-snug text-black font-bold">
          UX/UI Entwickler/in
        </h3>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Du bist ein/e stark eigenverantwortlich arbeitende/r UI/UX-Entwickler/in und möchtest Publishern dabei helfen, Ihre Geschäftsziele mit guter Gestaltung, intuitiven Oberflächen und einem ganzheitlichen Design-Anspruch zu helfen? 
          Dann melde Dich doch bei uns, denn wir suchen immer neue Talente.
        </p>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Wir bieten: Eine designgetriebene Umgebung mit fähigen Kolleg/innen, einem modernen React-Stack und Aktienoptionen an einem organisch wachsenden Unternehmen. Außerdem stellen wir Dir die Hardware, die Du brauchst: das Audyem-Team arbeitet remote.
        </p>
        <p className="text-lg mb-16 leading-snug text-gray-800">
          Sende Deine Bewerbungsunterlagen inklusive Lebenslauf und Links zu persönlicher Website oder Portfolio an <a className="text-black" href="mailto:join@audyem.com&subject=Bewerbung+als+UX/UI+Designer/in">join@audyem.com</a>. Wir freuen uns!
        </p>

        <h3 className="text-lg mb-6 leading-snug text-black font-bold">
          SaaS Sales Manager/in
        </h3>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Du bist ein/e stark eigenverantwortlich arbeitende/r Sales Manager/in und möchtest Publishern dabei helfen, Ihre Geschäftsziele mit Hilfe von Machine Learning und cleverer Datenauswertung zu erreichen?
          Dann melde Dich doch bei uns, denn wir suchen immer neue Talente.
        </p>
        <p className="text-lg mb-8 leading-snug text-gray-800">
          Wir bieten: Eine spannende Umgebung mit fähigen Kolleg/innen, einem modernen SaaS-Produkt und Aktienoptionen an einem organisch wachsenden Unternehmen. Außerdem stellen wir Dir die Hardware, die Du brauchst: das Audyem-Team arbeitet remote.
        </p>
        <p className="text-lg mb-8 md:mb-16 leading-snug text-gray-800">
          Sende Deine Bewerbungsunterlagen inklusive Lebenslauf und Links zu persönlicher Website und weiteren Materialien an  <a className="text-black" href="mailto:join@audyem.com&subject=Bewerbung+als+UX/UI+Designer/in">join@audyem.com</a>. Wir freuen uns!
        </p>
        
      </div>
    </div>
  </Layout>
)

export default IndexPage
